document.querySelectorAll('nav a').forEach(link => {
    const externalLinks = [
        'md-product.com',
          // List root domains only
    ];

    // Check if the link's href contains any of the root domains
    externalLinks.forEach(externalLink => {
        if (link.href.includes(externalLink)) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');  // Optional for security
        }
    });
});
